import sucursalXUsuarioService from '../services/sucursalXUsuarioService';

export interface SucursalUsuarioDraft {
  nroSuc: number;
  nombreSucursal: string;
  preferida: boolean;
}

export function mapAsignacionesToDraft(
  items: { nroSuc: number; nombreSucursal?: string | null; preferida: boolean }[]
): SucursalUsuarioDraft[] {
  return items.map((item) => ({
    nroSuc: item.nroSuc,
    nombreSucursal: item.nombreSucursal?.trim() || `Sucursal ${item.nroSuc}`,
    preferida: item.preferida,
  }));
}

export async function syncSucursalesUsuario(
  usuario: string,
  originales: SucursalUsuarioDraft[],
  draft: SucursalUsuarioDraft[]
): Promise<void> {
  const usuarioTrim = usuario.trim();
  if (!usuarioTrim) return;

  const origMap = new Map(originales.map((o) => [o.nroSuc, o]));
  const draftMap = new Map(draft.map((d) => [d.nroSuc, d]));

  for (const orig of originales) {
    if (!draftMap.has(orig.nroSuc)) {
      await sucursalXUsuarioService.delete(orig.nroSuc, usuarioTrim);
    }
  }

  for (const item of draft) {
    if (!origMap.has(item.nroSuc)) {
      await sucursalXUsuarioService.create({
        usuario: usuarioTrim,
        nroSuc: item.nroSuc,
      });
    }
  }

  const preferidaDraft = draft.find((d) => d.preferida);
  if (preferidaDraft) {
    const preferidaOrig = originales.find((o) => o.preferida);
    if (Number(preferidaDraft.nroSuc) !== Number(preferidaOrig?.nroSuc)) {
      await sucursalXUsuarioService.setPreferida(Number(preferidaDraft.nroSuc), usuarioTrim);
    } else if (!preferidaOrig) {
      await sucursalXUsuarioService.setPreferida(Number(preferidaDraft.nroSuc), usuarioTrim);
    }
  }
}

export async function syncSucursalPredeterminadaAdmin(
  usuario: string,
  originales: SucursalUsuarioDraft[],
  selected: SucursalUsuarioDraft | null
): Promise<void> {
  const usuarioTrim = usuario.trim();
  if (!usuarioTrim) return;

  for (const orig of originales) {
    if (!selected || Number(orig.nroSuc) !== Number(selected.nroSuc)) {
      await sucursalXUsuarioService.delete(Number(orig.nroSuc), usuarioTrim);
    }
  }

  if (!selected) return;

  const nroSuc = Number(selected.nroSuc);
  const existsInOrig = originales.some((o) => Number(o.nroSuc) === nroSuc);
  if (!existsInOrig) {
    await sucursalXUsuarioService.create({
      usuario: usuarioTrim,
      nroSuc,
    });
  }

  // Siempre marcar preferida: el create solo la setea si era la primera asignación.
  await sucursalXUsuarioService.setPreferida(nroSuc, usuarioTrim);
}

export function extractSucursalPredeterminadaAdmin(
  items: { nroSuc: number; nombreSucursal?: string | null; preferida: boolean }[]
): SucursalUsuarioDraft | null {
  if (items.length === 0) return null;
  const preferida = items.find((i) => i.preferida) ?? items[0];
  return {
    nroSuc: preferida.nroSuc,
    nombreSucursal: preferida.nombreSucursal?.trim() || `Sucursal ${preferida.nroSuc}`,
    preferida: true,
  };
}
